define('commons/operator-remember',['jquery', 'jquery-cookie'], function($) {
    // bind
    $('#operators').change(function(ev) {
        // store cookie
        $.cookie('SIGFOX_OPERATOR_REMEMBER', $(ev.currentTarget).val(), {path: "/", expires: 365});
    });
});
